<button
  class="button-AI"
  mat-icon-button
  [matTooltip]="'Chiedi all\'AI'"
  (click)="$event.stopPropagation(); askToAI()"
>
  <mat-icon svgIcon="follia_svg" inline="true" class="icona-follia"></mat-icon>
</button>
